var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "0 -9 511.9993 511",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#445ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#415a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#364d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a3d7c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 255.999758,
    x2: 255.999758,
    xlinkHref: "#a",
    y1: 448.3079974538,
    y2: 499.1077557524
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3d7c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3949,
    stopColor: "#273a77",
    stopOpacity: 0.396078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8504,
    stopColor: "#1e3069",
    stopOpacity: 0.85098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2b63"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 273.0776759264,
    x2: 265.9781403268,
    xlinkHref: "#c",
    y1: 506.8887536056,
    y2: 430.9798017728
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 189.1474877058,
    x2: 313.113884502,
    xlinkHref: "#a",
    y1: 383.7382442188,
    y2: 449.8172937886
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 278.302387191,
    x2: 248.8125800098,
    xlinkHref: "#c",
    y1: 472.7823107152,
    y2: 379.9441218042
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 255.999758,
    x2: 255.999758,
    xlinkHref: "#a",
    y1: 368.5763114294,
    y2: 429.2336802382
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#ffcb0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#ffa215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9517"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 232.3490623474,
    x2: 286.4076518502,
    xlinkHref: "#h",
    y1: 450.00673387,
    y2: 450.00673387
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 293.05451902,
    x2: 261.380277959,
    xlinkHref: "#c",
    y1: 448.4347928024,
    y2: 353.0480475022
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(.472345 -.88586 -.88586 -.472345 987.118581 1587.504287)",
    gradientUnits: "userSpaceOnUse",
    x1: 830.9987,
    x2: 773.3308,
    xlinkHref: "#h",
    y1: 1546.7002,
    y2: 1373.0336
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(-.472345 -.88586 .88586 -.472345 245.456363 1587.504287)",
    gradientUnits: "userSpaceOnUse",
    x1: 1168.7051,
    x2: 1111.0372,
    xlinkHref: "#h",
    y1: 913.348,
    y2: 739.6814
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 255.999758,
    x2: 255.999758,
    xlinkHref: "#h",
    y1: 378.4063140846,
    y2: 396.9774655938
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9517",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopColor: "#ee8421",
    stopOpacity: 0.305882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    stopColor: "#e07728",
    stopOpacity: 0.678431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db722b"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 262.2503771564,
    x2: 258.2456319062,
    xlinkHref: "#n",
    y1: 391.3935510376,
    y2: 338.2391940802
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 198.312392036,
    x2: 321.7323540876,
    xlinkHref: "#h",
    y1: 342.576538689,
    y2: 390.269861143
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 258.7551223212,
    x2: 252.5659431912,
    xlinkHref: "#n",
    y1: 382.3911816792,
    y2: 324.8679569622
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 255.999758,
    x2: 255.999758,
    xlinkHref: "#h",
    y1: 349.2805290206,
    y2: 372.3581859956
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 264.3790933652,
    x2: 256.733624982,
    xlinkHref: "#n",
    y1: 363.0634745508,
    y2: 300.8071591726
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 146.7784655788,
    x2: 373.8174337228,
    xlinkHref: "#h",
    y1: 210.934254673,
    y2: 210.934254673
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 233.6794597818,
    x2: 304.6736110714,
    xlinkHref: "#h",
    y1: 0.0394566032,
    y2: 206.468307656
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 255.9998583922,
    x2: 255.9998583922,
    xlinkHref: "#h",
    y1: 24.5286279102,
    y2: 125.10745701
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m394.824219 453.457031c0-22.535156-62.152344-40.804687-138.824219-40.804687s-138.824219 18.269531-138.824219 40.804687c0 22.535157 62.152344 40.804688 138.824219 40.804688s138.824219-18.269531 138.824219-40.804688zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m394.824219 453.457031c0-22.535156-62.152344-40.804687-138.824219-40.804687-48.796875 0-91.710938 7.402344-116.464844 18.59375v2.304687c0 7.417969 3.113282 14.308594 8.3125 19.191407l35.484375 35.484374c21.136719 3.828126 46.023438 6.035157 72.667969 6.035157 76.671875 0 138.824219-18.269531 138.824219-40.804688zm0 0",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m355.648438 458.101562c-64.109376 24.847657-135.1875 24.847657-199.296876 0-10.136718-3.929687-16.816406-13.683593-16.816406-24.550781v-44.160156h232.929688v44.160156c0 10.871094-6.679688 20.625-16.816406 24.550781zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m139.535156 415.746094 53.761719 53.765625c53.742187 12.546875 110.339844 8.746093 162.351563-11.410157 10.136718-3.929687 16.816406-13.683593 16.816406-24.554687v-44.15625h-232.929688zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m394.824219 395.886719c0-19.304688-62.152344-34.957031-138.824219-34.957031s-138.824219 15.652343-138.824219 34.957031c0 19.304687 62.152344 34.957031 138.824219 34.957031s138.824219-15.652344 138.824219-34.957031zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m186.273438 457.066406c45.5625 13.046875 93.886718 13.046875 139.449218 0 2.1875-.625 3.675782-2.644531 3.675782-4.914062v-13.863282c0-3.222656-2.941407-5.667968-6.097657-5.023437-22.019531 4.480469-44.660156 4.59375-67.300781 4.59375s-45.28125-.113281-67.300781-4.59375c-3.15625-.644531-6.101563 1.800781-6.101563 5.023437v13.863282c0 2.269531 1.492188 4.289062 3.675782 4.914062zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m256 360.929688c-18.59375 0-36.328125.921874-52.53125 2.59375v6.199218c-6.371094 2.882813-10.085938 6.320313-10.085938 10.011719 0 2.027344 1.132813 3.976563 3.195313 5.804687l45.121094 45.121094c4.703125.121094 9.472656.183594 14.300781.183594 1.257812 0 2.507812-.007812 3.757812-.015625.367188 0 .738282-.003906 1.105469-.007813.871094-.007812 1.746094-.015624 2.617188-.027343.460937-.007813.921875-.015625 1.382812-.023438.773438-.011719 1.542969-.023437 2.3125-.039062.496094-.011719.988281-.023438 1.480469-.035157.734375-.015624 1.46875-.03125 2.199219-.050781.503906-.015625 1.003906-.027343 1.503906-.042969.722656-.023437 1.441406-.042968 2.15625-.066406.5-.019531.996094-.035156 1.496094-.054687.710937-.023438 1.425781-.050781 2.136719-.082031.492187-.019532.988281-.039063 1.476562-.0625.722656-.03125 1.441406-.0625 2.15625-.097657.472656-.019531.941406-.042969 1.40625-.066406.746094-.039063 1.484375-.078125 2.222656-.117187.4375-.023438.875-.046876 1.3125-.074219.785156-.042969 1.570313-.089844 2.351563-.140625.378906-.019532.761719-.042969 1.140625-.066406.867187-.058594 1.726562-.117188 2.585937-.175782.292969-.019531.589844-.039062.886719-.058594 1.136719-.082031 2.273438-.164062 3.398438-.253906h.011718c2.339844-.183594 4.65625-.382812 6.941406-.59375.136719-.011718.269532-.023437.40625-.039062.980469-.089844 1.957032-.183594 2.925782-.28125.242187-.023438.480468-.050782.726562-.074219.859375-.089844 1.71875-.179687 2.570313-.269531l.84375-.09375c.8125-.089844 1.625-.179688 2.433593-.273438.28125-.03125.5625-.066406.84375-.097656.804688-.097656 1.601563-.191406 2.398438-.289062.273438-.035157.546875-.070313.820312-.105469.804688-.101563 1.601563-.203125 2.394532-.308594.257812-.035156.511718-.066406.765625-.101563.816406-.109374 1.625-.21875 2.429687-.332031.226563-.03125.449219-.066406.671875-.097656.855469-.121094 1.707031-.242187 2.546875-.371094.167969-.023437.332032-.046875.496094-.074219.945312-.140624 1.878906-.285156 2.808594-.433593.058594-.011719.121094-.019531.179687-.03125 5.09375-.8125 9.960938-1.707031 14.574219-2.675781.023438-.007813.046875-.011719.070312-.015626.882813-.183593 1.757813-.375 2.621094-.566406.074219-.015625.148438-.03125.222656-.046875.8125-.183593 1.621094-.363281 2.414063-.550781.097656-.023438.195313-.046875.292969-.066406.773437-.183594 1.539062-.367188 2.296875-.550782.101562-.027343.207031-.050781.3125-.078124.757812-.1875 1.503906-.375 2.246093-.566407.085938-.023437.175782-.046875.261719-.070312.761719-.195313 1.511719-.394531 2.257813-.597657.0625-.015624.121094-.03125.183594-.050781.789062-.214843 1.570312-.433593 2.339843-.652343.003907-.003907.011719-.003907.015625-.007813l-42.390625-42.390625c-.378906-.441406-.816406-.875-1.300781-1.300781-1.699219-1.984375-4.496094-3.839844-8.1875-5.511719v-6.195312c-16.207031-1.671876-33.9375-2.59375-52.53125-2.59375zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m92.628906 270.066406c-10.203125 0-20.371094-2.433594-29.691406-7.402344l-14.460938-7.710937c-22.285156-11.878906-38.28125-32.234375-45.046874-57.308594-6.679688-24.757812-3.535157-51.191406 8.859374-74.433593 11.933594-22.386719 34.503907-36.710938 58.898438-37.386719l.757812 27.296875c-14.609374.402344-28.234374 9.191406-35.5625 22.9375-9.117187 17.09375-11.457031 36.441406-6.589843 54.472656 4.777343 17.714844 15.976562 32.035156 31.527343 40.328125l14.464844 7.710937c13.472656 7.183594 30.285156 4.949219 42.835938-5.6875l17.65625 20.824219c-12.726563 10.792969-28.222656 16.359375-43.648438 16.359375zm0 0",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m419.371094 270.066406c10.203125 0 20.371094-2.433594 29.691406-7.402344l14.460938-7.710937c22.285156-11.878906 38.28125-32.234375 45.046874-57.308594 6.679688-24.757812 3.535157-51.191406-8.859374-74.433593-11.933594-22.386719-34.503907-36.710938-58.898438-37.386719l-.757812 27.296875c14.609374.402344 28.234374 9.191406 35.5625 22.9375 9.113281 17.09375 11.457031 36.441406 6.589843 54.472656-4.78125 17.714844-15.976562 32.035156-31.53125 40.328125l-14.460937 7.710937c-13.472656 7.183594-30.289063 4.949219-42.835938-5.6875l-17.660156 20.824219c12.726562 10.792969 28.226562 16.359375 43.652344 16.359375zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m318.617188 379.734375c0-10.164063-28.035157-18.40625-62.617188-18.40625s-62.617188 8.242187-62.617188 18.40625 28.035157 18.40625 62.617188 18.40625 62.617188-8.242187 62.617188-18.40625zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m318.617188 379.734375c0-10.164063-28.035157-18.40625-62.617188-18.40625-22.011719 0-41.367188 3.339844-52.53125 8.386719v1.039062c0 3.347656 1.402344 6.457032 3.746094 8.660156l16.007812 16.003907c9.53125 1.726562 20.757813 2.722656 32.777344 2.722656 34.582031 0 62.617188-8.242187 62.617188-18.40625zm0 0",
    fill: "url(#o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m300.945312 381.832031c-28.914062 11.203125-60.976562 11.203125-89.890624 0-4.574219-1.773437-7.585938-6.171875-7.585938-11.078125v-19.917968h105.0625v19.917968c0 4.90625-3.011719 9.304688-7.585938 11.078125zm0 0",
    fill: "url(#p)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m203.46875 362.726562 24.25 24.25c24.238281 5.660157 49.769531 3.945313 73.226562-5.144531 4.574219-1.773437 7.585938-6.171875 7.585938-11.078125v-19.917968h-105.0625zm0 0",
    fill: "url(#q)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m318.617188 353.769531c0-8.710937-28.035157-15.769531-62.617188-15.769531s-62.617188 7.058594-62.617188 15.769531c0 8.707031 28.035157 15.765625 62.617188 15.765625s62.617188-7.058594 62.617188-15.765625zm0 0",
    fill: "url(#r)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m256 338c-19.941406 0-37.695312 2.351562-49.160156 6.007812v1.71875l22.28125 22.285157c8.144531.972656 17.257812 1.523437 26.878906 1.523437 34.582031 0 62.617188-7.058594 62.617188-15.769531 0-8.707031-28.035157-15.765625-62.617188-15.765625zm0 0",
    fill: "url(#s)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m452.628906 64.941406v56.792969c0 32.417969-9.839844 63.195313-27.195312 88.917969-17.355469 25.722656-42.234375 46.363281-72.292969 58.5-28.996094 11.707031-47.980469 39.84375-47.980469 71.113281v5.460937c-1.167968 1.203126-2.585937 2.152344-4.214844 2.785157v.011719c-28.910156 11.207031-60.980468 11.207031-89.890624 0v-.011719c-1.628907-.632813-3.046876-1.582031-4.214844-2.785157v-5.460937c0-15.640625-4.75-30.484375-13.117188-42.890625-8.367187-12.40625-20.359375-22.367188-34.863281-28.222656-60.128906-24.257813-99.488281-82.59375-99.488281-147.417969v-56.792969zm0 0",
    fill: "url(#t)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m452.628906 64.941406c0-35.589844-88.035156-64.441406-196.628906-64.441406s-196.628906 28.851562-196.628906 64.441406 88.035156 64.441406 196.628906 64.441406 196.628906-28.851562 196.628906-64.441406zm0 0",
    fill: "url(#u)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m417.617188 57.472656c0-24.117187-72.359376-43.667968-161.617188-43.667968s-161.617188 19.550781-161.617188 43.667968c0 24.117188 72.359376 43.667969 161.617188 43.667969s161.617188-19.550781 161.617188-43.667969zm0 0",
    fill: "url(#v)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophy);
export default __webpack_public_path__ + "static/media/icon-trophy.4517294f3e5b094437f1f66fdb12cf1a.svg";
export { ForwardRef as ReactComponent };